import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getV2PricingPlans = async (selectedDomain: string, iso: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `pricing-plans`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params: { iso, isV2: true },
        isEncrypted: true,
    });
}